import { render, staticRenderFns } from "./c-history-list.vue?vue&type=template&id=6603a2c6&scoped=true"
import script from "./c-history-list.vue?vue&type=script&lang=js"
export * from "./c-history-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6603a2c6",
  null
  
)

export default component.exports